import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import { Table } from "antd";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ReactComponent as CategoryName } from "./Units Icons/Category Name.svg";
import { ReactComponent as CreatedAt } from "./Units Icons/Created Date.svg";
import { viewUnitList } from "../../Redux/Actions/unitsActions";
import { columnsUnits } from "../../Global Functions/columnsAntd";

const ViewUnits = () => {
  const { id } = useParams();
  const [foundUnit, setFoundUnit] = useState({});
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDetails = (page, limit) => {
    const unitData = {
      page,
      limit,
    };
    dispatch(viewUnitList(unitData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { units } = useSelector((state) => state.units);

  useEffect(() => {
    if (units?.total) {
      setPagination((prevData) => ({ ...prevData, total: units.total }));
    }
  }, [units]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    const mappedUnit = Array.isArray(units?.data)
      ? units.data.find((unit) => unit._id === id) || null
      : null;
    setFoundUnit(mappedUnit);
  }, [id, units]);

  return (
    <div>
      <div style={{ marginTop: "10px", width: "100%" }}>
        <SearchBar></SearchBar>
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "flex-start",
            marginLeft: "1.5vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Link to="/furnishing">
              <BackIcon style={{ cursor: "pointer" }} />
            </Link>
            <div>
              <h1>{foundUnit?.name || "No Data"}</h1>
              <h4
                style={{
                  position: "relative",
                  top: "-10px",
                  fontFamily: "Gilroy-Medium",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "100",
                  lineHeight: "10px",
                  left: "0px",
                }}
              >
                Furnishing/ List/ View
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          gap: "20px",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <div
          style={{
            marginLeft: "1.5vw",
            padding: "10px",
            display: "inline-block",
            width: "40%",
            minHeight: "100vh",
            background:
              "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
            borderRadius: "30px",
            flexDirection: "column",
            alignItems: "flex-start",
            position: "relative",
          }}
        >
          <div style={{ marginLeft: "1.5vw" }}>
            {canEdit &&
              <Link to={`/furnishing/edit/${id}`}>
                <button
                  style={{
                    position: "absolute",
                    top: "50px",
                    right: "70px",
                    padding: "12px 24px",
                    background:
                      "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
                    border: "1px solid white",
                    borderRadius: "5px",
                    cursor: "pointer",
                    color: "white",
                    fontFamily: "Gilroy-Bold",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "14.6px",
                  }}
                >
                  Edit
                </button>
              </Link>
            }
            <div>
              <span
                style={{
                  color: "#999",
                  position: "relative",
                  top: "1rem",
                  fontSize: "14px",
                }}
              >
                Category Name
              </span>
              <h1 style={{ color: "white" }}>{foundUnit?.name}</h1>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                marginLeft: "1.5vw",
                alignItems: "center",
                gap: "1vw",
              }}
            >
              <CategoryName></CategoryName>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1rem",
                    fontSize: "14px",
                  }}
                >
                  Category Name
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {foundUnit?.category_name}
                </h4>
              </div>
            </div>
            <div
              style={{
                marginLeft: "1.5vw",
                display: "flex",
                alignItems: "center",
                gap: "1vw",
              }}
            >
              <CreatedAt></CreatedAt>
              <div>
                <span
                  style={{
                    color: "#999",
                    position: "relative",
                    top: "1rem",
                    fontSize: "14px",
                  }}
                >
                  Created At
                </span>
                <h4 style={{ color: "white", fontSize: "20px" }}>
                  {foundUnit?.created_at
                    ? new Date(foundUnit.created_at).toLocaleString()
                    : "No Data Found"}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <span
          style={{ width: "100%", background: "white", borderRadius: "25px" }}
        >
          <div
            style={{
              paddingTop: "30px",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <h1>Unit List</h1>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc", // Border around the search bar
                borderRadius: "25px",
                padding: "5px 15px",
                width: "110vh", // Set the width of the search bar
                transition: "border-color 0.3s ease, box-shadow 0.3s ease",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                style={{
                  padding: "10px",
                  width: "100vh",
                  borderRadius: "25px",
                  border: ".01px solid #ccc",
                  fontSize: "16px",
                  // marginRight: "20vh", // Space between search bar and button
                  outline: "none", // Remove default focus outline
                  transition: "border-color 0.3s ease, box-shadow 0.3s ease", // Smooth transition for focus effect
                }}
                onFocus={(e) => {
                  e.target.style.border = ".01px solid #172358"; // Highlight border color on focus
                  e.target.style.boxShadow = "0 0 10px rgba(23, 35, 88, 0.5)"; // Light shadow effect
                }}
                onBlur={(e) => {
                  e.target.style.border = ".01px solid #ccc"; // Reset border when focus is lost
                  e.target.style.boxShadow = "none"; // Reset shadow effect
                }}
              />
            </div>
          </div>
          <Table
            columns={columnsUnits(canEdit)}
            // pagination={pagination}
            rowKey="_id"
            onChange={handleTableChange}
          // dataSource={Array.isArray(units?.data) && units.data}
          />
        </span>
      </div>
    </div>
  );
};

export default ViewUnits;
